function Card({ icon, title, description }) {
    return (
      <div style={styles.card}>
        <div style={styles.iconContainer}>
          {icon}
        </div>
        <h3 style={styles.title}>{title}</h3>
        <p>{description}</p>
      </div>
    );
  }
  
  const styles = {
    card: {
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
      textAlign: 'center',
      color: '#333',
    },
    iconContainer: {
      marginBottom: '20px',
    },
    title: {
      color: '#2E8B57',
      fontSize: '1.4rem',
      margin: '0 0 10px',
    },
  };
  
  export default Card;
  